import _ from "underscore";

export default {
  permission() {
    return !("Notification" in window) ? "unavailable" : Notification.permission;
  },

  requestPermission() {
    if (this.permission() === "unavailable") {
      return Promise.resolve("unavailable");
    } else {
      return Notification.requestPermission((permission) => {
        return Promise.resolve(permission);
      });
    }
  },

  notify(message, opts = {}, onClick = null) {
    if (this.permission() !== "granted") return;

    const n = new Notification(message, opts);

    n.addEventListener("click", (e) => {
      if (_.isFunction(onClick)) onClick(e);
    });
  }
};
